<template>
  <div>
    <my-dialog
      :width="748"
      :dialog-carted="showAudio"
      :is-show-footer="false"
      form-title="音频"
      @confirmOk="closeDialog"
    >
      <template #content>
        <el-table
          :data="collectWAV"
          border
          height="173"
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="59"
          />
          <el-table-column
            prop="fromW"
            label="音频"
            align="center"
            width="159"
          />
          <el-table-column
            prop="start"
            label="开始时间"
            align="center"
            width="159"
          />
          <el-table-column
            prop="start"
            label="结束时间"
            align="center"
            width="159"
          />
          <el-table-column
            prop=""
            label="操作"
            align="center"
            width=""
          >
            <template #default="{row}">
              <div v-if="row.id">
                <el-button
                  type="text"
                  @click="playRecoding($event, row.path)"
                >播放
                </el-button>
                <el-button
                  type="text"
                  @click="identify($event, row.id, row.wav_type)"
                >识别
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="textarea-text">
          <el-input v-model="copyText" type="textarea" :rows="6" placeholder="识别结果"/>
        </div>
        <div id="mse"/>
      </template>
    </my-dialog>
    <!--    各种提示-->
    <div class="info-dialog">
      <my-dialog
        :dialog-carted="infoDialog"
        :form-title="dialogTitle"
        :is-show-footer="isShowFooter"
        :width="390"
        @confirmOk="infoDialog = false"
      >
        <template #content>
          <div class="recognition-tip" style="height:200px;">
            {{ dialogMessage }}
          </div>
        </template>
      </my-dialog>
    </div>

  </div>
</template>
<script>
import { staticImage, baseUrl } from "@/utils/base";
import { getRecognition, getRecognitionNew } from "@/api/streamdata.js";
import { getCollectWAV, getTencentRecords } from "@/api/record.js";
import MyDialog from "@components/customDialog/MyDialog.vue";
import "@/assets/css/audioshow.scss";
import Music from "xgplayer-music";
import playbackRate from "xgplayer/dist/controls/playbackRate";
import { showWindowMessage } from "@utils/notification";

export default {
  name: "AudioShow",
  components: {
    MyDialog
  },
  props: {
    showAudio: {
      type: Boolean,
      default() {
        return false;
      }
    },
  },
  emits: ["closeDialog"],
  data() {
    return {
      collectWAV: [], // 收藏的音频
      staticImage: staticImage,
      baseUrl: baseUrl,
      dialogTitle: "",
      dialogMessage: "",
      isShowFooter: false,
      copyText: "", // 语音识别出来的文字
      player: null, // 播放器,
      infoDialog: false,
    };
  },
  watch: {
    showAudio: {
      handler(newVal, old) {
        if (newVal) {
          this.getRecording();
        } else {
          !!this.player && this.player.pause();
        }
      },
      immediate: true
    },
  },
  beforeUnmount() {
    window.clearTimeout(this.identifyTimer);
    this.identifyTimer = null;
    this.player?.destroy(false);
  },
  methods: {
    // 填满表格
    fillDrugsData(table, times) {
      for (let n = 0; n < times; n++) {
        const row = {};
        table.push(row);
      }
      this.collectWAV = table;
    },
    // 拿到wav音频
    async getRecording() {
      try {
        const id = this.$route.params.id;
        const { code, msg, data: res } = await getCollectWAV(id);
        if (code !== 200) {
          showWindowMessage(3, msg, this);
          return;
        }
        const len = res.length;
        if (len) {
          this.getPlayer(res[0]);
        }
        this.fillDrugsData(
          res,
          4 - len > 0 ? 4 - len : 0
        );
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    },
    /**
     * 初始化播放器
     * @param eg 默认音频所有数据的第一条数据
     */
    getPlayer(eg) {
      eg["src"] = this.baseUrl + eg.path;
      eg["vid"] = eg.id;
      eg["name"] = eg.formatTime;
      this.player = new Music({
        id: "mse",
        url: [eg],
        volumeShow: true,
        volume: 0.8,
        ignores: ["poster"],
        switchKeepProgress: true,
        controlPlugins: [
          playbackRate
        ],
        playbackRate: [0.5, 0.75, 1, 1.25], // 传入倍速可选数组
        defaultPlaybackRate: 1,
      });
      this.player.on("ended", () => {
        setTimeout(() => {
          // 播放器不会自动暂停, 只能自己手动暂停
          this.player.pause();
        }, 100);
      });
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    /**
     * 语音识别
     * @param {Object} event - event对象
     * @param {Number} id - id
     * @param {String} type - type
     * */
    async identify(event, id, type) {
      this.copyText = "";
      this.dialogTitle = "提示";
      this.dialogMessage = "正在识别,请稍后...";
      this.infoDialog = true;
      const form = { // 语音识别表单
        // method: "getWavText",
        id,
        wav_type: type
      };
      // 调用语音识别接口  || 后台调用
      this.identifyTimer = setInterval(async () => {
        try {
          const { code, text } = await getRecognitionNew(form);
          if (code === 200) {
            window.clearTimeout(this.identifyTimer);
            this.identifyTimer = null;
            await this.dealMessage(text);
          }
        } catch (e) {
          showWindowMessage(3, e, this);
        }
      }, 1500);
    },
    /**
     * 处理识别的结果
     * @param {String} text - 识别出来的文字
     * */
    async dealMessage(text) {
      if (text === "") {
        this.copyText = "未识别出任何文字";
      } else {
        this.copyText = text;
      }
      this.dialogTitle = "提示";
      this.dialogMessage = "识别成功";
      this.infoDialog = true;
      setTimeout(() => {
        this.infoDialog = false;
      }, 2000);
    },
    /**
     * 播放新录音
     * @param event 点击事件
     * @param content 行对象
     */
    playRecoding(event, content) {
      this.player.start(this.baseUrl + content);
      this.player.play();
    },
  }
};
</script>
<style lang="scss" scoped>
.textarea-text ::v-deep {
  margin-top: 20px;
  width: 100%;

  .el-textarea__inner {
    border-radius: 10px;
    background: #F0F5F7;
    font-size: 16px;
    color: #999999;
  }
}

// 语音识别提示
.recognition-tip {
  height: 100px;
  line-height: 100px;
}

::v-deep .el-table {
  border: 1px solid #999999;

  td, th.is-leaf {
    padding: 0;
    border-right: 1px solid #999999;
  }

  td, th.is-leaf {
    border-bottom: 1px solid #999999;
  }

  .cell {
    font-size: 14px;
    display: block;
  }

  th {
    background: #f4f4f4;

    .cell {
      height: 29px;
      line-height: 29px;
      color: #666666;
    }
  }

  td {
    background: #fbfbfb;

    .cell {
      height: 35px;
      line-height: 35px;
      color: #333333;
    }
  }

  .el-button.el-button--text {
    font-size: 14px;
    min-height: 16px;
    height: 16px;
    color: #2AA5E3;
  }
}

div.info-dialog ::v-deep {
  div.el-dialog__body {
    min-height: initial;
    //background-color: red;
  }
}
</style>
